export default __webpack_public_path__ + "static/media/nmbu_logo.dfd02eb7.png";